import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/predictions/ufc-today")({
  beforeLoad: () => {
    throw redirect({ href: "/mma-predictions/today", statusCode: 301 });
  },
});
